import { type FC, type ReactNode } from 'react';

import { StatsigProvider, useClientBootstrapInit } from '@statsig/react-bindings';

import { type PageAuth } from '@/src/components-v2/types';
import { type PageAuthType } from '@/src/middleware/pages';

interface BootstrappedFeatureFlagProviderProps {
  readonly auth: PageAuth<PageAuthType.Auth0>;
  readonly children: ReactNode;
  readonly clientInitializedData: string;
}

export const BootstrappedFeatureFlagProvider: FC<BootstrappedFeatureFlagProviderProps> = ({
  auth,
  children,
  clientInitializedData,
}) => {
  const client = useClientBootstrapInit(
    auth.env.statsig.clientKey,
    auth.statsig.user,
    clientInitializedData,
    { environment: { tier: auth.statsig.tier } },
    true,
  );
  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};
